import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import { parseDestHost, getQuery } from '@kso/axios/lib/util';
import { hosts } from '@kso/constants';
import { getUa } from '@kso/user-agent';

var KDOCS = hosts.KDOCS;
var DOCSK = hosts.DOCSK;
var EDU_KDOCS = hosts.EDUDOCS;
var ua = getUa(); // 获取所有ua
//  const DC_KDOCS = hosts.DCKDOCS // 自建应用域名

// 不符合 *.kdocs.cn = > *.wps.cn 的特殊域名转换
var SpecialRequest = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, 'adc.wps.cn', 'dc.kdocs.cn'), 'web.wps.cn', 'www.kdocs.cn'), 'docs-dapi.wps.cn', 'docer-api.kdocs.cn'), 'kvas-api.wps.cn', 'vas-api.kdocs.cn'), 'vip.wps.cn', 'vipapi.kdocs.cn');

// 实际金山文档 访问域名，除此之外标识为企业泛域名
var RealKdocsOrigin = ['test-edu.kdocs.cn', 'edu.kdocs.cn', 'pc.kdocs.cn', 'qr.kdocs.cn', 'internal.kdocs.cn', 'docs.kdocs.cn', 'www.kdocs.cn', 'pub.kdocs.cn', 'plus.kdocs.cn', 'kmon.kdocs.cn',
// 表单域名
'f.kdocs.cn', 'docer.kdocs.cn', 'docer-mo.kdocs.cn'];
var support3rdKdocsDoMain = ['rili.kdocs.cn', 'f.kdocs.cn', 'securitydoc.kdocs.cn', 'f-api.kdocs.cn', 'msgcenter.kdocs.cn', 'msgcenter.wps.cn'];

// 获取客户端接口返回的url获取host
var getHost = function getHost(url) {
  if (!url) {
    return '';
  }
  var regex = /https?:\/\/([^/:]+)/;
  var match = url.match(regex);
  return match ? match[1] : '';
};

// wps客户端和woa客户端因为file协议问题，需要特殊处理
var specialWPSOrigin = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(origin) {
    var domians, execService, res, _res$domain, domain;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          domians = ['kdocs']; // 具体服务对应的key
          _context.next = 3;
          return import('@wps/wps_client_api/exec');
        case 3:
          execService = _context.sent["default"];
          _context.next = 6;
          return execService.execPromise('common.network.getDomainUrl', {
            service: domians
          });
        case 6:
          res = _context.sent;
          if (!((res === null || res === void 0 ? void 0 : res.callstatus) === 'ok')) {
            _context.next = 12;
            break;
          }
          domain = getHost(res === null || res === void 0 || (_res$domain = res.domain) === null || _res$domain === void 0 ? void 0 : _res$domain.kdocs); // 如果返回的是www.kdocs.cn，不是企业自定义域名，返回之前的值。保持之前的逻辑
          if (!(domain === 'www.kdocs.cn')) {
            _context.next = 11;
            break;
          }
          return _context.abrupt("return", origin);
        case 11:
          return _context.abrupt("return", domain);
        case 12:
          return _context.abrupt("return", '');
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function specialWPSOrigin(_x) {
    return _ref.apply(this, arguments);
  };
}();
var isFileProtocol = typeof window !== 'undefined' && window.location.protocol === 'file:';
var interceptor = function interceptor(origin) {
  return {
    name: 'proxy2K3rd',
    request: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(config) {
        var specialFileOrigin, _parseDestHost, protocol, host, pathname, query, originIsKdocs, originIsKdoc, originIsWPS, originIsCustomDomain, isLocalOrigin, originIsDocerKdocs, requestIsWPS, requestIsKdocs, requestIsDocs, requestEqualKdocs, requestEqualMsgcenter, requestEqualTWPS, customDomainNeed3rd, urlQuery, newRequestHost, _newRequestHost, _newRequestHost2, hostsMatch, host3rd, _newRequestHost3, _hostsMatch, _host3rd, _hostsMatch2, _host3rd2, _hostsMatch3, _host3rd3;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              origin = origin || typeof window !== 'undefined' && window.location.hostname; // 在woa客户端调用，location.host为空
              if (!(isFileProtocol && ua.isWps)) {
                _context2.next = 6;
                break;
              }
              _context2.next = 4;
              return specialWPSOrigin(origin);
            case 4:
              specialFileOrigin = _context2.sent;
              origin = specialFileOrigin;
            case 6:
              if (isFileProtocol && ua.isWoa) {
                // woa客户端且是file协议
                origin = window.ksoxz_host || '';
              }
              _parseDestHost = parseDestHost(config), protocol = _parseDestHost.protocol, host = _parseDestHost.host, pathname = _parseDestHost.pathname, query = _parseDestHost.query;
              originIsKdocs = /^([\s\S]+?)\.(kdocs\.cn)$/.test(origin);
              originIsKdoc = /^([\s\S]+?)\.(kdoc\.cn)$/.test(origin);
              originIsWPS = /^([\s\S]+?)\.(wps\.cn)$/.test(origin);
              originIsCustomDomain = origin && !~RealKdocsOrigin.indexOf(origin) && /^([\s\S]+?)\.(kdocs\.cn)$/.test(origin) || false; // 是否自定义域名
              isLocalOrigin = false; // 本地化 本地化使用的是kdocs.cn 需要当成www.kdocs.cn处理不然会走3rd （不稳定）
              if (typeof window !== 'undefined' && window[window.clientApiKey] && window[window.clientApiKey].ajax) {
                originIsKdocs = true;
                isLocalOrigin = true;
              }
              originIsDocerKdocs = origin === 'docer.kdocs.cn'; // docer.kdocs.cn特殊处理不走3rd
              requestIsWPS = /^([\s\S]+?)\.(wps\.cn)$/.test(host);
              requestIsKdocs = /^([\s\S]+?)\.(kdocs\.cn)$/.test(host);
              requestIsDocs = host === 'docs.wps.cn';
              requestEqualKdocs = host === 'www.kdocs.cn';
              requestEqualMsgcenter = host === 'msgcenter.wps.cn'; // MSGCENTER特殊处理不走3rd
              requestEqualTWPS = host === 't.wps.cn'; // www.kdoc.cn时TWPS特殊处理
              customDomainNeed3rd = originIsCustomDomain && support3rdKdocsDoMain.includes(host); // let requestIsDC = (host === 'adc.wps.cn') // 自建应用域名
              /*
               * 如果访问域名是*.kdocs.cn 且 请求url是*.wps.cn
               * 企业泛域名访问，走3rd
               * docs.wps.cn的请求，url query里不带 keepHost 则使用 origin 替代
               * adc.wps.cn 要转为 dc.kdocs.cn
               * *.wps.cn 要转为 *.kdocs.cn
               */
              if (originIsKdocs && requestIsWPS) {
                if (requestIsDocs) {
                  // docs.wps.cn的请求直接用 origin 替代
                  urlQuery = {};
                  try {
                    urlQuery = getQuery(query) || {};
                  } catch (e) {
                    console.log(e);
                  }
                  // docs.wps.cn的请求，url query里不带 keepHost EDU_KDOCS & DOCSK & 自定义域名 使用请求域名，其余走KDOCS
                  if (!(urlQuery && urlQuery.keepHost)) {
                    newRequestHost = KDOCS;
                    if (origin === EDU_KDOCS || origin === DOCSK || originIsCustomDomain) {
                      newRequestHost = origin;
                    }
                    config.url = "".concat(protocol, "//").concat(newRequestHost).concat(pathname).concat(query);
                  }
                  // } else if (requestIsDC) {
                } else if (SpecialRequest && SpecialRequest[host]) {
                  /*
                   * 特殊域名配置
                   * adc.wps.cn 要转为 dc.kdocs.cn
                   * docer.wps.cn 要转为 docer-api.kdocs.cn
                   */
                  _newRequestHost = SpecialRequest[host];
                  config.url = "".concat(protocol, "//").concat(_newRequestHost).concat(pathname).concat(query);
                } else if (RealKdocsOrigin.indexOf(origin) === -1 && !isLocalOrigin) {
                  if (originIsCustomDomain && requestEqualMsgcenter && !customDomainNeed3rd) {
                    config.url = "".concat(protocol, "//msgcenter.kdocs.cn").concat(pathname).concat(query);
                  } else if (originIsDocerKdocs) {
                    // 特殊处理，*.wps.cn 要转为 *.kdocs.cn
                    _newRequestHost2 = host.replace(/\.wps\.cn$/, '.kdocs.cn');
                    config.url = "".concat(protocol, "//").concat(_newRequestHost2).concat(pathname).concat(query);
                  } else {
                    hostsMatch = host.match(/^([\s\S]+?)\.(wps|kdocs)\.cn$/);
                    host3rd = hostsMatch[1];
                    config.url = "".concat(protocol, "//").concat(origin, "/3rd/").concat(host3rd).concat(pathname).concat(query);
                  }
                } else {
                  // *.wps.cn 要转为 *.kdocs.cn
                  _newRequestHost3 = host.replace(/\.wps\.cn$/, '.kdocs.cn');
                  config.url = "".concat(protocol, "//").concat(_newRequestHost3).concat(pathname).concat(query);
                }
                /*
                 * 如果 访问域名不是wps.cn且请求域名是wps.cn
                 * 请求域名是 docs.wps.cn 直接用origin替代
                 * 其他请求则启用3rd访问
                 */
              } else if (origin && !originIsWPS && requestIsWPS) {
                if (requestIsDocs) {
                  // docs.wps.cn的请求直接用origin替代
                  config.url = "".concat(protocol, "//").concat(origin).concat(pathname).concat(query);
                } else if (requestEqualMsgcenter && !customDomainNeed3rd) {
                  config.url = "".concat(protocol, "//msgcenter.kdocs.cn").concat(pathname).concat(query);
                } else if (requestEqualTWPS && originIsKdoc) {
                  config.url = "".concat(protocol, "//t.kdocs.cn").concat(pathname).concat(query);
                } else {
                  _hostsMatch = host.match(/^([\s\S]+?)\.(wps\.cn)$/);
                  _host3rd = _hostsMatch[1];
                  config.url = "".concat(protocol, "//").concat(origin, "/3rd/").concat(_host3rd).concat(pathname).concat(query);
                }
                /*
                 * 如果 访问域名是www.kdoc.cn 且请求域名 www.kdocs.cn
                 * 直接用origin替代
                 * 其他请求则启用3rd访问
                 */
              } else if (origin && originIsKdoc && requestIsKdocs) {
                if (requestIsKdocs) {
                  // www.kdocs.cn 请求直接用origin替代
                  config.url = "".concat(protocol, "//").concat(origin).concat(pathname).concat(query);
                } else {
                  _hostsMatch2 = host.match(/^([\s\S]+?)\.(wps\.cn)$/);
                  _host3rd2 = _hostsMatch2[1];
                  config.url = "".concat(protocol, "//").concat(origin, "/3rd/").concat(_host3rd2).concat(pathname).concat(query);
                }
                /*
                 * 如果 访问域名是自定义域名 且请求域名 www.kdocs.cn
                 * 直接用origin替代
                 */
              } else if (originIsCustomDomain && requestEqualKdocs) {
                config.url = "".concat(protocol, "//").concat(origin).concat(pathname).concat(query);
              } else if (customDomainNeed3rd) {
                _hostsMatch3 = host.match(/^([\s\S]+?)\.(wps|kdocs)\.cn$/);
                _host3rd3 = _hostsMatch3[1];
                config.url = "".concat(protocol, "//").concat(origin, "/3rd/").concat(_host3rd3).concat(pathname).concat(query);
              }
              return _context2.abrupt("return", config);
            case 24:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function request(_x2) {
        return _request.apply(this, arguments);
      }
      return request;
    }()
  };
};
function proxy2K3rd (origin) {
  this.$inject(interceptor(origin));
}

export { proxy2K3rd as default, interceptor };
